var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsa2880351(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.452,
    height: 19.998,
    viewBox: "0 0 14.452 19.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "usa_2880351",
    transform: "translate(-71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75331",
    "data-name": "Path 75331",
    d: "M191.562,120.274l-.682-1.381-.682,1.381a.586.586,0,0,1-.441.321l-1.524.221,1.1,1.075a.586.586,0,0,1,.168.519l-.26,1.518,1.363-.717a.586.586,0,0,1,.545,0l1.363.717-.26-1.518a.586.586,0,0,1,.169-.519l1.1-1.075L192,120.595A.586.586,0,0,1,191.562,120.274Z",
    transform: "translate(-112.655 -114.249)",
    fill: "#7d96ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75332",
    "data-name": "Path 75332",
    d: "M84.977,5.981a2.134,2.134,0,0,1-.264-.493,2.223,2.223,0,0,1-.022-.588,2.279,2.279,0,0,0-.208-1.288,2.292,2.292,0,0,0-1.021-.829,2.181,2.181,0,0,1-.489-.3,2.179,2.179,0,0,1-.3-.489A2.292,2.292,0,0,0,81.84.968,2.279,2.279,0,0,0,80.552.76a2.223,2.223,0,0,1-.588-.022,2.135,2.135,0,0,1-.493-.264,1.872,1.872,0,0,0-2.49,0,2.134,2.134,0,0,1-.493.264A2.223,2.223,0,0,1,75.9.76a2.279,2.279,0,0,0-1.288.208,2.292,2.292,0,0,0-.829,1.021,2.181,2.181,0,0,1-.3.489,2.179,2.179,0,0,1-.489.3,2.292,2.292,0,0,0-1.021.829A2.279,2.279,0,0,0,71.76,4.9a2.223,2.223,0,0,1-.022.588,2.135,2.135,0,0,1-.264.493A2.34,2.34,0,0,0,71,7.226a2.34,2.34,0,0,0,.474,1.245,2.134,2.134,0,0,1,.264.493,2.223,2.223,0,0,1,.022.588,2.279,2.279,0,0,0,.208,1.288,2.292,2.292,0,0,0,1.021.829,2.182,2.182,0,0,1,.489.3,2.18,2.18,0,0,1,.3.489,2.292,2.292,0,0,0,.829,1.021,2.279,2.279,0,0,0,1.288.208,2.223,2.223,0,0,1,.588.022,2.135,2.135,0,0,1,.493.264,1.872,1.872,0,0,0,2.49,0,2.134,2.134,0,0,1,.493-.264,2.226,2.226,0,0,1,.588-.022,2.28,2.28,0,0,0,1.288-.208,2.292,2.292,0,0,0,.829-1.021,2.182,2.182,0,0,1,.3-.489,2.179,2.179,0,0,1,.489-.3,2.292,2.292,0,0,0,1.021-.829,2.279,2.279,0,0,0,.208-1.288,2.223,2.223,0,0,1,.022-.588,2.135,2.135,0,0,1,.264-.493,2.34,2.34,0,0,0,.474-1.245A2.341,2.341,0,0,0,84.977,5.981Zm-2.437.6L80.808,8.266l.409,2.384a.586.586,0,0,1-.85.618l-2.141-1.126-2.141,1.126a.586.586,0,0,1-.85-.618l.409-2.384L73.911,6.577a.586.586,0,0,1,.325-1L76.63,5.23,77.7,3.061a.586.586,0,0,1,1.051,0L79.822,5.23l2.394.348a.586.586,0,0,1,.325,1Z",
    transform: "translate(0 0)",
    fill: "#7d96ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75333",
    "data-name": "Path 75333",
    d: "M136.486,362.3a2.648,2.648,0,0,1-.486-.362v5.275a.586.586,0,0,0,.838.529l1.506-.717v-4.359c-.095,0-.2.007-.308.007A3.024,3.024,0,0,1,136.486,362.3Z",
    transform: "translate(-62.461 -347.798)",
    fill: "#7d96ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75334",
    "data-name": "Path 75334",
    d: "M226,393.237v3.307l1.172-.558,1.172.558v-3.307a2.731,2.731,0,0,1-2.343,0Z",
    transform: "translate(-148.946 -377.878)",
    fill: "#7d96ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75335",
    "data-name": "Path 75335",
    d: "M316.307,362.669c-.109,0-.213,0-.307-.007v4.359l1.506.717a.586.586,0,0,0,.838-.529v-5.275a2.653,2.653,0,0,1-.486.362A3.025,3.025,0,0,1,316.307,362.669Z",
    transform: "translate(-235.431 -347.797)",
    fill: "#7d96ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsa2880351);
export default __webpack_public_path__ + "static/media/usa_2880351.115a544ce2fa0ae1d1a21972cd2f686f.svg";
export { ForwardRef as ReactComponent };